import DocViewer, { DocViewerRenderers } from '@cyntler/react-doc-viewer';
import classNames from 'classnames';
import { useRef } from 'react';
import styles from '@/modules/admin-dashboard/components/modals/DocumentPreviewModal.module.scss';
import { BaseModalProps, ModalContentWrapper, Spinner, TextWithShortLinks } from 'ui';
import { PdfViewer } from 'ui/PDFViewer';
import { UserDocumentResponse } from 'compliance-api';
import '@cyntler/react-doc-viewer/dist/index.css';

const largePreviewFileTypes = [
  'pdf',
  'doc',
  'docx',
  'xls',
  'xlsx',
  'csv',
  'odt',
  'htm',
  'html',
  'ppt',
  'pptx',
];

interface DocumentPreviewModalProps extends BaseModalProps {
  doc: UserDocumentResponse;
  isLargePreviewAlways?: boolean;
}

const DocumentPreviewModal = ({
  open,
  doc,
  onClose,
  isLargePreviewAlways = false,
}: DocumentPreviewModalProps) => {
  const printRef = useRef<HTMLDivElement>(null);

  const isLargePreviewFileType =
    largePreviewFileTypes.includes(doc.format || '') || isLargePreviewAlways;

  const isPdf = doc.format === 'pdf';
  const isImage = ['webp', 'bmp', 'gif', 'jpg', 'jpeg', 'png', 'hiff'].includes(doc?.format || '');

  return (
    <ModalContentWrapper
      title={`${doc.name}.${doc.format}`}
      open={open}
      onClose={onClose}
      classes={{ dialogPanel: classNames({ '!max-w-[920px]': isLargePreviewFileType }) }}
    >
      <div className="flex flex-col gap-3" ref={printRef}>
        {isPdf && <PdfViewer enableZoom src={doc.url || ''} className={styles.pdfViewerWrapper} />}
        {isImage && <img alt="" src={doc.url} />}
        {!isPdf && !isImage && (
          <DocViewer
            config={{
              header: { disableHeader: true },
              loadingRenderer: {
                overrideComponent: () => (
                  <div className="h-[250px≈] flex items-center justify-center">
                    <Spinner />
                  </div>
                ),
              },
            }}
            pluginRenderers={DocViewerRenderers}
            documents={[{ fileType: doc.format, uri: doc.url || '' }]}
            className={classNames(
              '[&_[id="txt-renderer"]]:break-all [&_[id="txt-renderer"]]:max-h-[400px] [&_[id="txt-renderer"]]:overflow-y-auto [&_[id="proxy-renderer"]]:overflow-y-auto',
              '[&_[id="image-renderer"]]:bg-none',
              { '!h-[700px] [&>div]:h-full [&>div>div]:h-full': isLargePreviewFileType },
            )}
          />
        )}

        <TextWithShortLinks text={doc.description ?? ''} />
      </div>
    </ModalContentWrapper>
  );
};

export default DocumentPreviewModal;

// const handlePrint = useCallback(() => {
//   const content = printRef.current;
//   if (!content) return;
//
//   const printWindow = window.open('', '', 'width=800,height=600');
//
//   if (!printWindow) return;
//
//   printWindow.document.write(`
//     <html>
//       <body>
//         ${content.outerHTML}
//       </body>
//     </html>
//   `);
//
//   printWindow.document.close();
//   printWindow.focus();
//
//   setTimeout(() => {
//     // printWindow.print();
//     // printWindow.close();
//   }, 3000);
// }, []);

// const title = (
//   <div className="flex gap-2">
//     <div>{doc.name}</div>
//     <button onClick={handlePrint}>print</button>
//   </div>
// );
